import Axios from "axios";

export type CEP = {
  cep: string;
  logradouro: string;
  complemento: string;
  unidade: "";
  bairro: string;
  localidade: string;
  uf: string;
  estado: string;
  regiao: string;
};

export const validateCEP = async (cep: string): Promise<CEP> => {
  const response = await Axios.get(`https://viacep.com.br/ws/${cep}/json/`);
  return response.data;
};
